export function isIosSafariVideoGestureRequired(userAgent: string, ontouchendInDocument: boolean): boolean {
  return /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes('Mac') && ontouchendInDocument);
}

export function shouldAutoDismissMobileAttractOverlay(options: {
  isMobileDevice: boolean;
  iosGestureRequired: boolean;
}): boolean {
  return options.isMobileDevice && !options.iosGestureRequired;
}
